import React from 'react';
import pl_PL from './pl_PL'
import en_GB from './en_GB'
// import de_DE from './de_DE'
// import gr_GR from './gr_GR'
// // import AsyncStorage from '@react-native-async-storage/async-storage';
// import { store} from '../../App';

const languageSwitcher = (languageCode) => {
    switch(languageCode)
    {
        case 'en_GB':
            return en_GB;
        case 'pl_PL': 
            return pl_PL;
        case 'de_DE': 
            return de_DE;
        case 'gr_GR': 
            return gr_GR;
        default:
            return en_GB;
    }
}

import T from './../containers/T';
import TImage from './../containers/TImage';

const t = (translationKey) => {

    // const defaultUserLanguage = 'en_GB';
    // // if(store && store.getState){
    // //     defaultUserLanguage = store.getState().language;
    // // }
    // // try {
    // //     const value = await AsyncStorage.getItem('language')
    // //     if(value !== null) {
    // //         defaultUserLanguage = value;
    // //     }
    // //     } catch(e) {
    // //     // error reading value
    // //     }  
    // // console.log('defaultUserLanguage',defaultUserLanguage);
    // if(translationKey === 'loading')
    // {
    //     console.log(defaultUserLanguage);
    // }
    // const translations = languageSwitcher(defaultUserLanguage);

    // return translations[translationKey];

    return <T>{translationKey}</T>
  }


  const tSaga = (translationKey, defaultUserLanguage) => {

    // const defaultUserLanguage = 'en_GB';
    // // if(store && store.getState){
    // //     defaultUserLanguage = store.getState().language;
    // // }
    // // try {
    // //     const value = await AsyncStorage.getItem('language')
    // //     if(value !== null) {
    // //         defaultUserLanguage = value;
    // //     }
    // //     } catch(e) {
    // //     // error reading value
    // //     }  
    // // console.log('defaultUserLanguage',defaultUserLanguage);
    // if(translationKey === 'loading')
    // {
    //     console.log(defaultUserLanguage);
    // }
    const translations = languageSwitcher(defaultUserLanguage);

    return translations[translationKey];

   // return <T>{translationKey}</T>
  }


export const tImage = (translationKey,styles) => {

  
    return <TImage styles={styles}>{translationKey}</TImage>
  }
export default t;

export { tSaga };